import React from "react";
import { MessageCircle } from "lucide-react";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export default function WhatsAppFloatingButton() {
  const { settings } = useSiteSettings();
  const phone = settings.whatsapp_number ? settings.whatsapp_number.replace(/[^0-9]/g, "") : "923000000000";

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Assalam o Alaikum! I am contacting you from Anwer Fancy Lace website. I want to inquire about fancy lace sets and wholesale rates."
    );
    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 flex items-center gap-2">
      <div className="hidden sm:block bg-[#1C1917] text-[#E6C687] text-xs font-semibold py-1.5 px-3 rounded-full border border-[#D4AF37]/50 shadow-xl animate-bounce">
        Order on WhatsApp 💬
      </div>
      <button
        type="button"
        onClick={handleWhatsAppClick}
        data-testid="floating-whatsapp-btn"
        className="w-14 h-14 bg-emerald-700 hover:bg-emerald-800 text-white rounded-full flex items-center justify-center shadow-2xl ring-4 ring-[#D4AF37]/50 hover:scale-110 transition-all duration-300 group"
        aria-label="Direct WhatsApp Order"
      >
        <MessageCircle className="w-7 h-7 fill-current" />
      </button>
    </div>
  );
}
